// @ts-nocheck
import React from 'react'
import { connect } from 'react-redux'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import {
  DocumentsModuleCard,
  EmarModuleCard,
  GroupPlanModuleCard,
  PaywallTemplate,
} from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { HomeSource } from '@lmc/ts-common'

interface StateProps {
  subscribeTo: () => void
  getSubscriptions: () => void
  subscriptionCancelled?: boolean
  role?: string
  title?: string
  subTitle?: string
  source?: HomeSource
  preferredPeopleNominative?: string
}

export const FamilyPortalPaywallComponent: React.FC<StateProps> = ({
  subscribeTo,
  getSubscriptions,
  subscriptionCancelled,
  role,
  source,
}) => {
  React.useEffect(() => {
    getSubscriptions()
  }, [])

  const ctaDisabled = role === 'senior-carer' || subscriptionCancelled
  let disabledText
  if (subscriptionCancelled) {
    disabledText = 'Note: Sorry, you have already completed a free trial.'
  } else if (role === 'senior-carer') {
    disabledText = 'Note: Only admins can start a free trial.'
  }

  const isSelfServe = source === 'Self-serve'

  return (
    <PaywallTemplate
      backgroundColor="#FF9900"
      title="Family Portal"
      subTitle="Show the quality of your service and bring out the human touch by keeping relatives updated about their loved one’s care, wellbeing and health."
      bodyText={
        isSelfServe
          ? 'Set up the Family Portal to best fit your care service'
          : 'Use the Family Portal to improve communication.'
      }
      cta="Start Free Trial"
      onClick={subscribeTo}
      icon={IconType.FamilyHexagon}
      videoUrl="https://www.youtube.com/embed/2XCgAbKwzvQ"
      articles={[
        {
          title: 'How can I set up and manage the Family Portal?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/collections/2560231-manage-your-family-portal',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white,
        },
        {
          title: 'How can families stay informed?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/collections/2616115-help-for-families-and-loved-ones-using-the-app',
          iconBackgroundColour: colors.green,
          iconColour: colors.white,
        },
        {
          title: 'What can I do with the Family Portal add-on?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/2455677-family-portal',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white,
        },
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={
        isSelfServe ? <DocumentsModuleCard /> : <GroupPlanModuleCard />
      }
      ctaDisabled={ctaDisabled}
      disabledText={disabledText}
      findOutMoreURL={
        isSelfServe
          ? 'https://support.logmycare.co.uk/en/articles/4498174-how-can-i-set-up-the-family-portal'
          : 'https://www.logmycare.co.uk/features/updating-family-friends'
      }
      source={source}
      customLinkText="Read more"
    />
  )
}

const mapStateToProps = (state: any) => ({
  subscriptionCancelled: Selectors.isSubscriptionCancelled(
    state,
    'pro-monthly'
  ),
  role: state.global?.user?.role,
  source: state.global?.home?.source,
})

const mapDispatchToProps = (dispatch: any) => ({
  subscribeTo: () =>
    dispatch(
      Operations.openNewPlan({
        planId: 'pro-monthly',
      })
    ),
  getSubscriptions: () => dispatch(Operations.getSubscriptions()),
})

export const FamilyPortalPaywall = connect(
  mapStateToProps,
  mapDispatchToProps
)(FamilyPortalPaywallComponent)
